import React, { createContext, useContext } from 'react';

export type NavigationSizeSetting = 'auto' | 'forceCompressed' | 'forceExpanded';

// Define the context value type
interface NavigationSizeContextType {
  size: NavigationSizeSetting;
  setSize: React.Dispatch<React.SetStateAction<NavigationSizeSetting>>;
}

// Create the context with a default value of undefined
export const NavigationSizeContext = createContext<NavigationSizeContextType | undefined>(undefined);

export const useNavigationSize = (): NavigationSizeContextType => {
  const context = useContext(NavigationSizeContext);
  if (!context) {
    throw new Error('useNavigationSize must be used within a NavigationSizeProvider');
  }
  return context;
};
